export const enumPermisosBloqueosCierreFinanciero = Object.freeze({
  BLOQUEOS_COMERCIOS_CIERRE_FINANCIERO: 36013,
});

